import { render, staticRenderFns } from "./showNoticeMsg.vue?vue&type=template&id=ba1a0bfc&scoped=true&"
import script from "./showNoticeMsg.vue?vue&type=script&lang=js&"
export * from "./showNoticeMsg.vue?vue&type=script&lang=js&"
import style0 from "./showNoticeMsg.vue?vue&type=style&index=0&id=ba1a0bfc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba1a0bfc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/www/game/xcp-vue-xcll/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ba1a0bfc')) {
      api.createRecord('ba1a0bfc', component.options)
    } else {
      api.reload('ba1a0bfc', component.options)
    }
    module.hot.accept("./showNoticeMsg.vue?vue&type=template&id=ba1a0bfc&scoped=true&", function () {
      api.rerender('ba1a0bfc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/xcpOpsManager/noticeComponent/showNoticeMsg.vue"
export default component.exports